import { render, staticRenderFns } from "./SwiperDemo.vue?vue&type=template&id=83796748&scoped=true"
import script from "./SwiperDemo.vue?vue&type=script&lang=js"
export * from "./SwiperDemo.vue?vue&type=script&lang=js"
import style0 from "./SwiperDemo.vue?vue&type=style&index=0&id=83796748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83796748",
  null
  
)

export default component.exports